// lib
import { configureStore } from "@reduxjs/toolkit";
// src
import rootReducer from "reducers";
import { appGoesActive, appGoesIdle } from "actions/system";
import { windowResize } from "actions/ux";
import { hydrate } from "utils/storage";

const store = configureStore({
  reducer: rootReducer,
  immutableCheck: false,
  serializableCheck: false,
});

// auto dispatch!
window.addEventListener("resize", () => {
  store.dispatch(windowResize());
});

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    const { idleSince } = store.getState().system;
    const idleDuration = Date.now() - idleSince;
    setTimeout(() => store.dispatch(appGoesActive(idleDuration)), 500);
  } else {
    store.dispatch(appGoesIdle());
  }
});

hydrate(store.dispatch);

export default store;
